import React from 'react';
import {
    ShippingText,
    NoInventoryShippingDiv,
    Div,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const NoInventoryShippingNonTissueSet = ({ onClose, message }) => {
    const { validatedProducts } = useSelector((state) => ({
        validatedProducts: state.validateProductsReducer.validatedProducts.some(
            (data) => data.productCFN.includes('B33')
        ),
    }));
    const {t} = useTranslation();
    return (
        <>
            <Popup
                title={
                    validatedProducts
                        ? t('equity.surgery.notifications.unidRods')
                        : t('equity.surgery.notifications.noInventoryShipping')
                }
                id={'surgery-notification-noInventoryShipping-popup'}
                onClose={onClose}
                img={AlertCircleOutline}
            >
                <NoInventoryShippingDiv>
                    <ShippingText>
                        {message
                            ? message
                            : validatedProducts
                            ? t('equity.surgery.notifications.pleaseContactYourUnid')
                            : t('equity.surgery.notifications.onlyNonTissue')}
                    </ShippingText>
                    <Div>
                        <Button
                            id={'surgery-notifications-noinventoryshippingnontissueset-okbutton'}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                            // primary={true}
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                           {t('scheduleSurgery.surgery.notifications.DraftSaved.okButton')}
                        </Button>
                    </Div>
                </NoInventoryShippingDiv>
            </Popup>
        </>
    );
};

export default NoInventoryShippingNonTissueSet;
